import { Component, Input } from '@angular/core';
import { Vacation } from '@lx/quote-tool/shared/types';

@Component({
  selector: 'lx-holiday-closures',
  templateUrl: './holiday-closures.component.html',
  styleUrls: ['./holiday-closures.component.scss'],
})
export class HolidayClosuresComponent {
  @Input() holidayClosuresDates: Vacation[] = [];
}
